import { useLazyQuery, useMutation } from '@apollo/client';
import { Box, TextField } from '@material-ui/core';
import CustomizeLayoutQuiz from 'component/layout_quiz/layout_quiz';
import { useAuth } from 'contexts/AuthContext';
import { useSpinnerLoading } from 'hooks/useSpinnerLoading';
import { useEffect, useMemo, useState, useCallback } from 'react';
import isUrl from 'validator/lib/isURL';
import _valuesIn from 'lodash/valuesIn';
import _isEqual from 'lodash/isEqual';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { EQuizId, ESubjectQuestion, quizContextType } from 'types/quiz';
import { CREATE_ANSWERS, ValueType } from '../../../graph_ql/getQuiz/mutation';
import { GET_QUIZ_RESPONSE } from '../../../graph_ql/getQuiz/queries';
import { useGetGender } from '../../../hooks/useGetGender';
import { PATH } from '../../../routes/constant';
import { useStyles } from './styles';
import { TextErr } from 'component/customize_style_component/styled_title';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { trackEvent, TRACK_EVENT } from 'utils/analytics';
export interface ISocialMediaProps {}

interface Ianswer {
    title?: string;
    value?: string;
    id?: String;
    answerId?: string;
    userProperty?: string;
    isSkipped?: string;
}

interface Imutation {
    questionId?: String;
    questionSubject?: String;
    contextType?: String;
    contextId?: String;
    value?: String;
    valueType?: String;
    id?: String;
    isSkipped?: boolean;
}

const SocialMedia = () => {
    const { userName } = useParams<{ userName: string }>();
    const { currentUser } = useAuth();
    const history = useHistory();
    const gender = useGetGender(Boolean(userName));
    const location = useLocation();
    const classes = useStyles();
    const [requiredQuestion, setRequiredQuestion] = useState(true);
    const [quizData, setQuizData] = useState<any>(null);
    const [loadingSkip, setLoadingSkip] = useState<any>(false);
    const [questionList, setQuestionList] = useState<any>([]);
    const [initialQuestionList, setInitialQuestionList] = useState<any>([]);
    const me = useSelector((state: RootState) => state.userDetail.me);

    const [getQuizResponse, { loading: loadingQuiz }] = useLazyQuery(GET_QUIZ_RESPONSE, {
        onCompleted(data) {
            setRequiredQuestion(data.getQuizResponse?.questionsInfo[0]?.required);
            setQuizData(data.getQuizResponse);
            const listAnswers = _valuesIn(data.getQuizResponse?.answers);
            const listQuestions = _valuesIn(data.getQuizResponse?.questions);
            const list = listQuestions
                .sort((a, b) => a.displayOrder - b.displayOrder)
                .map((item) => {
                    const itemAnswered = listAnswers.find((i) => i.questionId === item.id);
                    let updatedItem = {
                        ...item,
                        value: '',
                    };
                    if (itemAnswered) {
                        updatedItem = {
                            ...updatedItem,
                            value: itemAnswered.value,
                            answerId: itemAnswered.id,
                            isSkipped: itemAnswered.isSkipped,
                        };
                    }
                    return updatedItem;
                });
            setQuestionList(list);
            setInitialQuestionList(list);
        },
    });

    const [answersMutation, { loading: loadingAnswer }] = useMutation(CREATE_ANSWERS, {
        onCompleted(response) {
            onAnswerCompleted();
        },
        onError(error) {
            console.log('Create Failed: ', error);
        },
    });

    const handleSkipEvent = useCallback(() => {
        trackEvent(TRACK_EVENT.USER_SOCIAL_MEDIA_SKIP, {
            userId: me?.id,
            userType: me?.userType,
            email: me?.email,
            socialMediaUrls: {},
            userProperty: '',
            isSkipped: true,
        });
    }, [me]);

    const onAnswerCompleted = useCallback(async () => {
        await getQuizResponse({
            variables: {
                input: {
                    quizId: EQuizId.SOCIAL_MEDIA_QUIZ,
                    contextType: quizContextType,
                    contextId: EQuizId.SOCIAL_MEDIA_QUIZ,
                    userId: currentUser.uid || gender?.id,
                },
            },
        });
        location.pathname === PATH.SOCIAL_MEDIAS
            ? history.push(PATH.PROFILE)
            : history.push(`${PATH.QUIZ_MANAGER}/?signup=${Date.now()}`);
    }, [currentUser.uid, gender?.id, getQuizResponse, history, location.pathname]);

    useEffect(() => {
        if (currentUser || gender) {
            getQuizResponse({
                variables: {
                    input: {
                        quizId: EQuizId.SOCIAL_MEDIA_QUIZ,
                        contextType: quizContextType,
                        contextId: EQuizId.SOCIAL_MEDIA_QUIZ,
                        userId: currentUser.uid || gender?.id,
                    },
                },
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentUser.uid, gender]);

    const validAnswer = useMemo(() => {
        const foundSelectedItem = questionList.find((item) => item.value);
        return foundSelectedItem ? true : false;
    }, [questionList]);

    const getValidationMessage = (id) => {
        if (id.includes('linkedin')) {
            return `Invalid profile link`;
        }
        return `Invalid username or profile link`;
    };

    const isValidUrl = (urlString, item) => {
        var parser = document.createElement('a');
        let validUrl = true;
        let validatedConnectedAccounts = questionList.map((question) => {
            if (question.id === item.id) {
                parser.href = urlString;
                let hostName = question.id.split('_');
                hostName = hostName[hostName.length - 1];
                if (
                    parser.protocol &&
                    parser.hostname?.toLowerCase()?.includes(hostName?.toLowerCase()) &&
                    parser.pathname.replaceAll('/', '') &&
                    isUrl(urlString)
                ) {
                    return question;
                } else {
                    validUrl = false;
                    return { ...question, validationMessage: getValidationMessage(item.id) };
                }
            } else {
                return question;
            }
        });
        setQuestionList(validatedConnectedAccounts);
        return validUrl;
    };

    const createAnswers = useCallback(
        async ({ skip = false }) => {
            let modifiedList: Ianswer[] = [];
            questionList.forEach((question) => {
                if (!question.value && !question.isSkipped) {
                    modifiedList = [...modifiedList, question];
                } else {
                    initialQuestionList.forEach((initialQuestion) => {
                        if (question.id === initialQuestion.id && !_isEqual(question, initialQuestion)) {
                            modifiedList = [...modifiedList, question];
                        }
                    });
                }
            });
            let answerList = skip ? initialQuestionList : modifiedList;
            if (answerList.length) {
                let answers: Imutation[] = [];
                answerList.forEach((item) => {
                    let input: Imutation = {
                        contextId: EQuizId.SOCIAL_MEDIA_QUIZ,
                        contextType: quizContextType,
                        questionSubject: ESubjectQuestion.SOCIAL_MEDIA,
                        valueType: ValueType.String,
                        questionId: item.id,
                        value: item.value || '',
                        id: item?.answerId,
                        isSkipped: !item.value,
                    };
                    answers = [...answers, input];
                });

                const SaveMultipleAnswers = () => {
                    const variables = {
                        input: {
                            answers,
                        },
                    };
                    answersMutation({ variables });
                };
                if (answers.length) {
                    SaveMultipleAnswers();
                }

                if (skip) {
                    setLoadingSkip(skip);
                    handleSkipEvent();
                }
            } else {
                onAnswerCompleted();
            }
        },
        [answersMutation, questionList, onAnswerCompleted, initialQuestionList, handleSkipEvent],
    );

    const handleClickAnswer = () => {
        const invalidLink = questionList.filter((item) => item.validationMessage);
        if (!invalidLink?.length) {
            createAnswers({ skip: false });
        }
    };

    const handleOnFieldChange = (e, item) => {
        let updateQuestionList = questionList.map((option) => {
            if (option.id === item.id) {
                const { validationMessage, ...restData } = option;
                return { ...restData, value: e.target.value };
            }
            return option;
        });
        setQuestionList(updateQuestionList);
    };
    const updateFieldValueWithUrl = (url, item) => {
        let updateQuestionList = questionList.map((option) => {
            if (option.id === item.id) {
                return { ...option, value: url };
            }
            return option;
        });
        setQuestionList(updateQuestionList);
    };
    const handleOnFieldBlur = async (e, item) => {
        if (
            (item.id === 'social_media_quiz_question_instagram' ||
                item.id === 'social_media_quiz_question_tiktok' ||
                item.id === 'social_media_quiz_question_snapchat') &&
            e.target.value
        ) {
            let domain = '';
            switch (item.id) {
            case 'social_media_quiz_question_instagram':
                domain = 'https://instagram.com';
                break;
            case 'social_media_quiz_question_tiktok':
                domain = 'https://tiktok.com';
                break;
            case 'social_media_quiz_question_snapchat':
                domain = 'https://snapchat.com/add';
                break;
            default:
                break;
            }
            const validateUrl = (urlString) => {
                if (isUrl(urlString)) {
                    if (urlString.includes('/')) {
                        isValidUrl(urlString, item);
                    } else {
                        updateFieldValueWithUrl(`${domain}/${e.target.value}`, item);
                    }
                } else if (urlString.split(' ')?.length === 1) {
                    updateFieldValueWithUrl(`${domain}/${e.target.value}`, item);
                } else {
                    isValidUrl(urlString, item);
                }
            };
            validateUrl(e.target.value);
        } else if (item.id === 'social_media_quiz_question_linkedin' && e.target.value) {
            isValidUrl(e.target.value, item);
        }
    };
    useSpinnerLoading('loadingQuiz', loadingQuiz);

    return (
        <CustomizeLayoutQuiz
            quizId={EQuizId.SOCIAL_MEDIA_QUIZ}
            title={quizData?.subTitle}
            titlePage={quizData?.title}
            handleAnswer={handleClickAnswer}
            isUpdate={location.pathname === PATH.SOCIAL_MEDIAS}
            isDisplayContent={true}
            hideBottomNav={location.pathname === PATH.QUIZ_MANAGER}
            requiredQuestion={requiredQuestion}
            handleSkipQuestion={() => createAnswers({ skip: true })}
            loadingSkip={loadingAnswer && loadingSkip}
            loading={loadingAnswer && !loadingSkip}
            nextBtnDisabled={location.pathname === PATH.QUIZ_MANAGER ? !validAnswer : false}
        >
            <Box
                display={'flex'}
                flexDirection={'column'}
                justifyContent={'center'}
                width={'100%'}
                height={'100%'}
                padding={'16px'}
            >
                <div>
                    {questionList.map((item) => (
                        <div className={classes.customTextField} key={item.id}>
                            <div className={classes.fieldLabel}>{item.title}</div>
                            <div className={classes.fieldContainer}>
                                <TextField
                                    id={item.id}
                                    className={classes.textField}
                                    placeholder={item.placeHolder}
                                    onChange={(e) => handleOnFieldChange(e, item)}
                                    value={item.value}
                                    onBlur={(e) => handleOnFieldBlur(e, item)}
                                />
                                {item.validationMessage && (
                                    <TextErr style={{ display: 'block' }}>{item.validationMessage}</TextErr>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </Box>
        </CustomizeLayoutQuiz>
    );
};
export default SocialMedia;
